import PricingProviderType from '@/enums/valuation/PricingProviderType';
import ValuationVehicle from './ValuationVehicle';

export default class Valuation {
  public registration: string = '';

  public mileage: number = 0;

  public privateClean: number = 0;

  public privateAverage: number = 0;

  public partExchange: number = 0;

  public tradeAverage: number = 0;

  public tradePoor: number = 0;

  public valuationTime: Date = new Date();

  public vehiclePricingProviderType: PricingProviderType = PricingProviderType.UkVehicleData;

  public vehicle: ValuationVehicle = new ValuationVehicle();
}
